export const ANALYTICS_TYPES = {
  TRACK_CLICK: 'analytics/track_click',
  TRACK_IMPRESSION: 'analytics/track_impression',
}

export function initialize() {
  if (window.PAYPAL && window.PAYPAL.analytics) {
    window.PAYPAL.analytics.setupComplete = paypalAnalyticsSetupCompleted
    // call it anyway,
    // in case there's a weird race condition where `setupComplete` is already called from the analytics lib
    // before this was loaded.
    paypalAnalyticsSetupCompleted()
  }
}

export function paypalAnalyticsSetupCompleted() {
  if (_initialized) return // don't init twice
  if (!window.PAYPAL.analytics.instance) return // don't init if the analytic lib doesn't have a an instance yet

  _initialized = true
  _flushQueue()
}

export function trackImpression(pageName, campaignId, flow, poolOwner) {
  track(ANALYTICS_TYPES.TRACK_IMPRESSION, {
    pageName,
    campaignId,
    flow,
    poolOwner,
  })
}

export function trackClick(payload) {
  track(ANALYTICS_TYPES.TRACK_CLICK, payload)
}

export function track(type, payload) {
  if (_initialized) {
    switch (type) {
      case ANALYTICS_TYPES.TRACK_CLICK:
        _trackClick(payload)
        break
      case ANALYTICS_TYPES.TRACK_IMPRESSION:
        _trackImpression(payload)
        break
      default:
        break
    }
  } else {
    _enqueueEvent(type, payload)
  }
}

let _initialized = false

// This queue is here to prevent a race condition.
// Since an analytics event can fire before the analytics client-side script
// has been initialized, we're queuing the events that fired while it's initializing,
// and fire all of them sequentially once initialization has completed.
let _q = []

function _flushQueue() {
  while (_q.length) {
    const ev = _q.shift()
    track(ev.type, ev.payload)
  }
}

function _enqueueEvent(type, payload) {
  _q.push({ type, payload })
}

function _trackClick({ clickName, data = {} }) {
  if (clickName) {
    window.fpti.pgln = `${window.fpti.page}|${clickName}`
    window.fpti.pglk = `${window.fpti.pgrp}|${clickName}`
    window.fpti.link = clickName

    // apply extra fields to window.fpti
    Object.assign(window.fpti, data)

    // actually record the click
    window.PAYPAL.analytics.instance.recordClick()

    // remove those additional keys for subsequent calls
    Object.keys(data).forEach(key => {
      delete window.fpti[key]
    })
  }
}

function _trackImpression({ pageName, campaignId, flow, poolOwner }) {
  pageName = `main:pools:${pageName}`

  window.fpti.page = pageName + ':::'
  window.fpti.pgrp = pageName
  window.fpti.link = undefined
  window.fpti.cmpn_id = campaignId
  window.fpti.encr_rcvr_id = poolOwner
  window.fpti.flow = flow
  window.PAYPAL.analytics.instance.recordImpression()
}
